import { useMemo } from 'react';
import cx from 'classnames';

import { getRiskTypeByValue } from '@/helpers';

import styles from './AnalyzeItemScoreIndicator.module.sass';

interface AnalyzeItemScoreIndicatorProps {
  value: number;
}

export const AnalyzeItemScoreIndicator = ({
  value,
}: AnalyzeItemScoreIndicatorProps) => {
  const riskType = useMemo(() => getRiskTypeByValue(value), [value]);

  const classes = cx(styles.indicator, styles[`indicator--${riskType}`]);

  return (
    <div className={classes}>
      <span className={styles.value}>{value}%</span>
      <span className={styles.risk}>Risk</span>
    </div>
  );
};
